// import { buildStars } from 'Functions/rating';
import { updateLazy } from "Functions/lazy";
import { scrollToEl } from "Functions/window";
import { initAnchors } from "Functions/anchor";
import { initWishlists } from "Common/wishlist";

import "Layouts/default";

import "Ui/shorten";
import "Ui/tabs";
import "Ui/toggle";
import "Components/modal/modal-remote";
import "Components/modal/modal-watchdog";
import { initCountdowns } from "Functions/countdown";

import "./catalog-jquery";
import { initSets } from "./catalog-sets";
import "./categories-filter";
import "./price-filter-babys";
import "./multiselect";
import "./filter-bubbles";
import { initTippy } from "Functions/tippy";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll(".pager__list .c-btn")) {
        if (pagerButton.classList.contains("is-active")) continue;

        pagerButton.addEventListener("click", (event) => {
            scrollToEl(
                document.querySelector(".c-listing-main__products"),
                parseInt(
                    getComputedStyle(document.documentElement).getPropertyValue("--header-height")
                )
            );
        });
    }
};

rEvent.on("Listing.fetchedData", () => {
    initSets();
    updateLazy();
    attachPaginatorEvents();
    initAnchors();
    initTippy();
    initTippy(".js-tippy-availability", {
        theme: "availability",
        maxWidth: "520px",
    });
    initWishlists();
});

document.addEventListener("DOMContentLoaded", function () {
    attachPaginatorEvents();
    initAnchors();
    initSets();
    initCountdowns();
});

document.querySelector("#filter-wrapper").addEventListener("rToggle.afterOpen", (event) => {
    const trigger = event.detail.origEvent.target.closest("[r-toggle-trigger]");
    const target = event.target;

    if (trigger.dataset.tabId) {
        if (
            target.querySelector(
                `[r-tab-trigger][data-tab-id="filter-tab-${trigger.dataset.tabId}"]`
            )
        ) {
            target
                .querySelector(`[r-tab-trigger][data-tab-id="filter-tab-${trigger.dataset.tabId}"]`)
                .click();
        }
    }
});

const manufacturerFilterTriggers = document.querySelector(".js-manufacturer-filter-triggers");

if (manufacturerFilterTriggers) {
    manufacturerFilterTriggers
        .querySelectorAll(".js-trigger-manufacturer-filter")
        .forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
                event.preventDefault();

                const id = trigger.dataset.id;

                document
                    .getElementById("filter[manufacturers][]")
                    .querySelector(`option[value="${id}"]`).selected = true;
                $(document.getElementById("filter[manufacturers][]")).change();
            });
        });
}

document.querySelector(".c-filter-sub").addEventListener("rTab.after.openTab", (event) => {
    updateLazy();
});
const enablerParam = 'recombee=';

const defaultGridFilter = enablerParam  + '&f=view%3Dgrid%7Cprice%5B%5D%3D1%2C376%7Csort%3Dpurchases%3Ad';
const hideElementIfUrlHasParams = (selector) => {
    const checkUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlParamsString = urlParams.toString();
        const element = document.querySelector(selector);
        if (element) {
            if (urlParamsString && (urlParamsString !== defaultGridFilter && urlParamsString !== enablerParam)) {
                element.style.display = "none";
            } else {
                element.style.display = ""; // Reset to default
            }
        }
    };

    // Initial check on page load
    checkUrlParams();

    // Observe URL changes
    let lastUrl = window.location.href;
    const observer = new MutationObserver(() => {
        if (lastUrl !== window.location.href) {
            lastUrl = window.location.href;
            checkUrlParams();
        }
    });

    // Observe changes to the <body> element (attribute changes for SPA URL changes)
    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
};

hideElementIfUrlHasParams(".c-listing-products__holder.is-recommended");